"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"
const WarningIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g>
      <path d="M1.81718 14C1.69496 14 1.58384 13.9694 1.48384 13.9083C1.38384 13.8472 1.30607 13.7667 1.25051 13.6667C1.19496 13.5667 1.1644 13.4583 1.15884 13.3417C1.15329 13.225 1.18384 13.1111 1.25051 13L7.41718 2.33333C7.48384 2.22222 7.56996 2.13889 7.67551 2.08333C7.78107 2.02778 7.8894 2 8.00051 2C8.11162 2 8.21996 2.02778 8.32551 2.08333C8.43107 2.13889 8.51718 2.22222 8.58384 2.33333L14.7505 13C14.8172 13.1111 14.8477 13.225 14.8422 13.3417C14.8366 13.4583 14.8061 13.5667 14.7505 13.6667C14.695 13.7667 14.6172 13.8472 14.5172 13.9083C14.4172 13.9694 14.3061 14 14.1838 14H1.81718ZM2.96718 12.6667H13.0338L8.00051 4L2.96718 12.6667ZM8.00051 12C8.1894 12 8.34773 11.9361 8.47551 11.8083C8.60329 11.6806 8.66718 11.5222 8.66718 11.3333C8.66718 11.1444 8.60329 10.9861 8.47551 10.8583C8.34773 10.7306 8.1894 10.6667 8.00051 10.6667C7.81162 10.6667 7.65329 10.7306 7.52551 10.8583C7.39773 10.9861 7.33384 11.1444 7.33384 11.3333C7.33384 11.5222 7.39773 11.6806 7.52551 11.8083C7.65329 11.9361 7.81162 12 8.00051 12ZM8.00051 10C8.1894 10 8.34773 9.93611 8.47551 9.80833C8.60329 9.68056 8.66718 9.52222 8.66718 9.33333V7.33333C8.66718 7.14444 8.60329 6.98611 8.47551 6.85833C8.34773 6.73056 8.1894 6.66667 8.00051 6.66667C7.81162 6.66667 7.65329 6.73056 7.52551 6.85833C7.39773 6.98611 7.33384 7.14444 7.33384 7.33333V9.33333C7.33384 9.52222 7.39773 9.68056 7.52551 9.80833C7.65329 9.93611 7.81162 10 8.00051 10Z" />
    </g>
  </svg>,
  "Settings",
)

const SmallWarningIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return (
    <WarningIcon sx={{ width: 16, height: 16, fill: _fill, ...sx }} {...rest} />
  )
}

export default SmallWarningIcon
